import { useTranslation } from 'react-i18next';
import { cn } from '@shared/lib';

interface ModuleAuthorProps {
  name: string | null;
  /** Модуль команды Lomora: оранжевый аватар и галочка. */
  official: boolean;
  /** Вторая строка под именем, например «Команда Lomora · 412 установок». */
  role?: string;
}

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => Array.from(word)[0].toLocaleUpperCase())
    .join('');
}

/** Автор публичного модуля: аватар с инициалами, имя и роль. */
export function ModuleAuthor({ name, official, role }: ModuleAuthorProps) {
  const { t } = useTranslation();
  const author = name?.trim() || (official ? 'Lomora' : t('library.role.community'));

  return (
    <span className="lb-author">
      {/* amp-mask / ym-hide-content: имя и инициалы автора-пользователя не попадают в записи сессий. */}
      <span className={cn('lb-avatar', official ? 'lb-avatar--official' : 'amp-mask ym-hide-content')} aria-hidden="true">
        {official ? 'L' : initialsOf(author)}
      </span>
      <span className="lb-author-text">
        <span className="lb-author-name">
          <span className={official ? undefined : 'amp-mask ym-hide-content'}>{author}</span>
          {official && (
            <svg className="lb-verified" viewBox="0 0 24 24" role="img" aria-label={t('library.verified')}>
              <circle cx="12" cy="12" r="10" fill="var(--color-accent)" />
              <path
                d="M7.5 12.3l3 3 6-6.3"
                fill="none"
                stroke="var(--color-fg-inv)"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
        {role && <span className="lb-author-role">{role}</span>}
      </span>
    </span>
  );
}
